<div *ngIf="show" class="d-flex justify-content-center h-100 m-auto">
    <mat-spinner></mat-spinner>
</div>
